/**
 * 수량 스테퍼 (.stepper) — − · + 버튼으로 숫자 입력을 올리고 내린다.
 *
 * 한도와 간격은 input 의 min · max · step 을 따른다. 값을 바꾼 뒤 input 이벤트를 내보내므로
 * 폼(주문 폼의 합계 계산 등)은 직접 입력과 똑같이 반응한다. 한도에 닿은 쪽 버튼은 비활성이 된다.
 * 버튼이 여러 화면에 흩어져 있어서 문서 한 곳에서 위임으로 받는다.
 */

const number = (value, fallback) => {
  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : fallback;
};

/** 한도에 맞춰 버튼 상태를 맞춘다 */
const refresh = (root) => {
  const input = root.querySelector('.stepper__input');
  const down = root.querySelector('[data-stepper-down]');
  const up = root.querySelector('[data-stepper-up]');

  if (!(input instanceof HTMLInputElement)) {
    return;
  }

  const value = number(input.value, 0);
  const min = input.min === '' ? -Infinity : number(input.min, -Infinity);
  const max = input.max === '' ? Infinity : number(input.max, Infinity);

  if (down) {
    down.disabled = input.disabled || value <= min;
  }

  if (up) {
    up.disabled = input.disabled || value >= max;
  }
};

const InitStepper = () => {
  const roots = document.querySelectorAll('[data-stepper]');

  if (0 === roots.length) {
    return;
  }

  roots.forEach(refresh);

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-stepper-down], [data-stepper-up]');
    const root = button?.closest('[data-stepper]');
    const input = root?.querySelector('.stepper__input');

    if (!button || !(input instanceof HTMLInputElement) || input.disabled) {
      return;
    }

    event.preventDefault();

    const step = Math.max(1, number(input.step, 1));
    const min = input.min === '' ? -Infinity : number(input.min, -Infinity);
    const max = input.max === '' ? Infinity : number(input.max, Infinity);
    const direction = button.hasAttribute('data-stepper-up') ? 1 : -1;
    const next = Math.min(max, Math.max(min, number(input.value, 0) + direction * step));

    if (next === number(input.value, 0)) {
      refresh(root);
      return;
    }

    input.value = String(next);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    refresh(root);
  });

  // 직접 입력했을 때도 버튼 상태를 맞춘다
  document.addEventListener('input', (event) => {
    const root = event.target.closest?.('[data-stepper]');

    if (root) {
      refresh(root);
    }
  });
};

export default InitStepper;
